export const AllPositions = {
    TOP_START: 'top-start',
    TOP: 'top',
    TOP_END: 'top-end',
    RIGHT_START: 'right-start',
    RIGHT: 'right',
    RIGHT_END: 'right-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM: 'bottom',
    BOTTOM_END: 'bottom-end',
    LEFT_START: 'left-start',
    LEFT: 'left',
    LEFT_END: 'left-end',
    CENTER: 'center',
};

export const SNACKBAR_POSITIONS = [
    AllPositions.TOP_START,
    AllPositions.TOP,
    AllPositions.TOP_END,
    AllPositions.BOTTOM_END,
    AllPositions.BOTTOM,
    AllPositions.BOTTOM_START,
];

export const FLOAT_POSITIONS = [
    AllPositions.TOP_START,
    AllPositions.TOP,
    AllPositions.TOP_END,
    AllPositions.RIGHT_START,
    AllPositions.RIGHT,
    AllPositions.RIGHT_END,
    AllPositions.BOTTOM_END,
    AllPositions.BOTTOM,
    AllPositions.BOTTOM_START,
    AllPositions.LEFT_END,
    AllPositions.LEFT,
    AllPositions.LEFT_START,
];

export const APP_POSITIONS = [
    AllPositions.TOP_START,
    AllPositions.TOP,
    AllPositions.TOP_END,
    AllPositions.RIGHT_START,
    AllPositions.RIGHT,
    AllPositions.RIGHT_END,
    AllPositions.BOTTOM_END,
    AllPositions.BOTTOM,
    AllPositions.BOTTOM_START,
    AllPositions.LEFT_END,
    AllPositions.LEFT,
    AllPositions.LEFT_START,
    AllPositions.CENTER,
];
